var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-lg-0 mb-5"},[_c('st-button',{attrs:{"id":"st_login_facebook","block":true,"callback":_vm.getLoginStatus,"customClass":"font-size-h4"}},[_c('b-icon-facebook',{staticClass:"p-1"}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }